import { FC, RefObject } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { WorkspaceSettingsPages } from "./constants";
import { BillingPage } from "./Billing/BillingPage";
import { PlansPage } from "./Plans/PlansPage";
import { WorkspaceMembers } from "./WorkspaceMembers/WorkspaceMembers";
import { IntegrationsSettings } from "./Integrations/IntegrationsSettings";
import { WorkspaceLock } from "./Lock/WorkspaceLock";
import { AccountingSettings } from "./AccountingSettings/AccountingSettings";
import { SettingsTabPane } from "./SettingsTabPane";
import { BillingTransferPage } from "./BillingTransfer/BillingTransferPage";
import { WorkspaceDocumentInbox } from "./WorkspaceReceipts/WorkspaceDocumentInbox";
import { WorkspaceTaskGroups } from "./WorkspaceTaskGroups/WorkspaceTaskGroups";
import { SendingDomainsSettings } from "./SendingDomains/SendingDomainsSettings";

interface Props {
    scrollbars: RefObject<Scrollbars | null>;
}

export const WorkspacePanes: FC<Props> = ({ scrollbars }) => (
    <>
        <SettingsTabPane eventKey={WorkspaceSettingsPages.MEMBERS}>
            <WorkspaceMembers />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.TASK_GROUPS}>
            <WorkspaceTaskGroups />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.INTEGRATIONS}>
            <IntegrationsSettings scrollbars={scrollbars} />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.LOCKS}>
            <WorkspaceLock />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.ACCOUNTING}>
            <AccountingSettings />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.BILLING}>
            <BillingPage />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.BILLING_TRANSFER}>
            <BillingTransferPage />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.PLANS}>
            <PlansPage />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.DOCUMENT_INBOX}>
            <WorkspaceDocumentInbox />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.SENDING_DOMAINS}>
            <SendingDomainsSettings />
        </SettingsTabPane>
    </>
);
